import { DatePipe, KeyValuePipe, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { HelpPageRoutingModule } from './help-routing.module';
import { HelpPageComponent } from './help.component';

@NgModule({
  declarations: [HelpPageComponent],
  imports: [HelpPageRoutingModule, IonicModule, TitleCasePipe, KeyValuePipe, MiscModule, DatePipe]
})
export class HelpPageModule {}
